export default (product) => ({
	id: product.id,
	name: product.name,
	variant: product.variant,
	category: product.category.string,
	price: product.price.street.unformatted,
	quantity: product.quantity,
	position: product.position,
	dimension37: product.dimension37
});
